import objectToQueryString from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';
import moment from 'moment';

export default {
	getCommCodes: codeType => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getPartCost: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		let searchDate;
		if (searchParams.stdDt !== undefined || searchParams.partNm !== undefined) {
			if (searchParams.stdDt) {
				searchDate = moment(searchParams.stdDt).format('YYYY-MM-DD');
			} else {
				searchDate = '';
			}
			queryStr = objectToQueryString({
				stdDt: searchDate,
				partScn: searchParams.partScn,
				partNo: searchParams.partNo,
				cpnyCd: searchParams.cpnyCd,
				dlvgNm: searchParams.dlvgNm,
				partG:  searchParams.partG,
				currentPage,
				pageUnit
			});
		}
		return client
			.get(`${BASE_URL}/comm/qmsbase/partCost/v1/partCosts` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	// 저장
	async postPartCost({ saveParams }) {
		try {
			const response = await client.post(`${BASE_URL}/comm/qmsbase/partCost/v1/status/2`, saveParams);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async excelTempDown(params) {
		// 엑셀템플릿 다운로드
		try {
			const response = await client.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downExcelTemp`, params, {
				responseType: 'blob'
			});
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
